export const WRAP_DISPLAY_BREAKPOINT = '500px';
export const PAGE_CONTAINER_MAX_WIDTH = '1300px';
